import { gql } from '@apollo/client';

export const GET_SUPPORT_QUESTIONS = gql`
  query getSupportQuestions(
    $pagination: PaginationArg
    $filters: FaqFiltersInput
  ) {
    faqs(pagination: $pagination, filters: $filters) {
      data {
        attributes {
          question
          answer
          category
        }
      }
    }
  }
`;
